import { initializeSentry } from './config/sentry';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { configureAmplify } from './config/amplify';
import { loadAndValidateConfig } from './config/loader';
import { setAppConfig } from './config/environment';
import './index.css';
import App from './App.tsx';

// Initialize Sentry as the very first thing before React app initialization
initializeSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount the application.");
}

const root = createRoot(rootElement);

// Asynchronous application initialization
(async () => {
  try {
    // 1. Load and validate the configuration from runtime-config.json and env vars
    const config = await loadAndValidateConfig();

    // 2. Set the configuration globally so it can be imported by other modules
    setAppConfig(config);

    // 3. Configure Amplify with the loaded and validated configuration
    configureAmplify(config);

    // 4. Render the main application
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } catch (error) {
    // If configuration fails, render an error message to the user
    console.error("Application initialization failed:", error);
    root.render(
      <div style={{ padding: '20px', textAlign: 'center', fontFamily: 'sans-serif' }}>
        <h1>Application Error</h1>
        <p>Could not initialize the application due to a configuration error.</p>
        <p>Please contact support or try again later.</p>
        <pre style={{ marginTop: '20px', padding: '10px', background: '#f0f0f0', borderRadius: '4px', textAlign: 'left', display: 'inline-block' }}>
          <code>{error instanceof Error ? error.message : String(error)}</code>
        </pre>
      </div>
    );
  }
})();
